import api from "./api";

export const StatusesAPI = {
  list: () => api("/statuses"),
  create: (data) =>
    api("/statuses", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  update: (id, data) =>
    api(`/statuses/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),
  delete: (id) =>
    api(`/statuses/${id}`, {
      method: "DELETE",
    }),
};

export const CategoriesAPI = {
  list: () => api("/categories"),
  create: (data) =>
    api("/categories", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  update: (id, data) =>
    api(`/categories/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),
  delete: (id) =>
    api(`/categories/${id}`, {
      method: "DELETE",
    }),
};

export const DepartmentsAPI = {
  listDefaultRecipes: () => api("/departments/default-recipes"),
  list: () => api("/departments"),

  create: (data) =>
    api("/departments", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (id, data) =>
    api(`/departments/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),

  delete: (id) =>
    api(`/departments/${id}`, {
      method: "DELETE",
    }),

  // Inbound mailboxes
  listInboundMailboxes: () =>
    api("/departments/inbound-mailboxes"),

  createInboundMailbox: (data) =>
    api("/departments/inbound-mailboxes", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  updateInboundMailbox: (id, data) =>
    api(`/departments/inbound-mailboxes/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),

  deleteInboundMailbox: (id) =>
    api(`/departments/inbound-mailboxes/${id}`, {
      method: "DELETE",
    }),
};

export const SubcategoriesAPI = {
  list: (categoryId) => api(`/categories/${categoryId}/subcategories`),
  create: (categoryId, data) =>
    api(`/categories/${categoryId}/subcategories`, {
      method: "POST",
      body: JSON.stringify(data),
    }),
  update: (categoryId, id, data) =>
    api(`/categories/${categoryId}/subcategories/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),
  delete: (categoryId, id) =>
    api(`/categories/${categoryId}/subcategories/${id}`, {
      method: "DELETE",
    }),
};